import React, { useState, useEffect } from "react"
import { toast } from 'react-toastify'
import Loading from "../../components/Loading"
import TextInput from './../TextInput'
import Pagination from './../Pagination'
import BooksTable from './../notes/BooksTable'
import TakenExamDetailModal from './TakenExamDetailModal'
import MessageBox from './../MessageBox'

import DropDown from "../DropDown"

import Search from './../../images/icons/search.png'
import Archive from './../../images/icons/archive.png'
import UnArchive from './../../images/icons/unarchive.png'

import { apiCall, validateToken, detectDifficulty, detectExamStatus } from './../../../Helper'

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  const [showDetailModal, setShowDetailModal] = useState(false)

  const [selectedExam, setSelectedExam] = useState({})

  const [selectedStatus, setSelectedStatus] = useState({ id: 0, title: 'همه' })
  const [selectedDifficulty, setSelectedDifficulty] = useState({ id: 0, title: 'همه' })

  const [exams, setExams] = useState([])
  const [archivedExams, setArchivedExams] = useState([])
  const [count, setCount] = useState(0)
  const [archivedCount, setArchivedCount] = useState(0)
  const [page, setPage] = useState(1)
  const [archivedpage, setArchivedPage] = useState(1)
  const [q, setQ] = useState('')
  const [activeTab, setActiveTab] = useState(1)

  const [focusedExamId, setFocusedExamId] = useState(-1)

  function getExams() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/takenExam',
      params: {
        q, page: page - 1, difficulty: selectedDifficulty.id || '', _status: selectedStatus.id || ''
        // group_id: routes.length > 0 ? routes[routes.length - 1].id : '', 
        // price: selectedPrice.id || ''
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        setExams(res.data.taken_exams)
        setCount(res.data.count)
        setArchivedExams(res.data.archived_taken_exams)
        setArchivedCount(res.data.archived_count)
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function archiveExam() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/takenExam',
      method: 'put',
      data: {
        taken_exam_id: focusedExamId
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        if (res.data.code === 0) {
          toast.success('ثبت موفقیت آمیز')
          setFocusedExamId(-1)
          getExams()
        } else toast.error('مشکل در سیستم')
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  useEffect(() => validateToken(), [])

  useEffect(() => {
    if (!isLoading)
      getExams()
  }, [selectedDifficulty, selectedStatus, page])

  useEffect(() => {
    if (q === '')
      getExams()
  }, [q])

  useEffect(() => { if (!showDetailModal) setSelectedExam({}) }, [showDetailModal])

  return (
    <div>
      <h3 className="m-0 text-shadow font-16 pr-16">کارنامه ها</h3>
      <hr className="mb-0" />

      {/* filters and dropdowns */}
      <div className="p-32 pb-0 flexed justify-between">
        <div>
          <DropDown className="w-256 ml-32" name="وضعیت" items={[{ id: 0, title: 'همه' }, { id: 1, title: 'قبول' }, { id: 2, title: 'مردود' }]}
            onItemClick={item => setSelectedStatus(item)} selectedItem={selectedStatus} />

          <DropDown className="w-256" name="سطح" items={[{ id: 0, title: 'همه' }, { id: 1, title: 'آسان' }, { id: 2, title: 'متوسط' }, { id: 3, title: 'سخت' }]}
            onItemClick={item => setSelectedDifficulty(item)} selectedItem={selectedDifficulty} />
        </div>
        <TextInput className="w-256" placeholder="جستجو در کارنامه ها" icon={Search} onChange={e => setQ(e.target.value)} value={q} onClick={getExams} onKeyDown={e => {
          if (e.keyCode === 13) getExams()
        }} />
      </div>

      {/* tabs */}
      <div className="p-32 pb-0">
        <div className="grid" style={{
          gridTemplateColumns: '1fr 1fr',
          gridColumnGap: 32
        }}>
          <button onClick={() => setActiveTab(1)}
            className="bd-none py-8 px-16 radius-4 text-shadow iran-sans one-line"
            style={{ backgroundColor: 'rgba(255, 255, 255, .7)', opacity: activeTab === 1 ? 1 : .4 }}>
            <span className="font-13">همه</span>
          </button>
          <button onClick={() => setActiveTab(2)}
            className="bd-none py-8 px-16 radius-4 text-shadow iran-sans one-line"
            style={{ backgroundColor: 'rgba(255, 255, 255, .7)', opacity: activeTab === 2 ? 1 : .4 }}>
            <span className="font-13">آرشیو شده</span>
          </button>
        </div>
      </div>

      {/* the table */}
      <div className="mt-16">
        {(activeTab === 1 ? exams : archivedExams).length > 0 ? <BooksTable
          showRowIndex
          className="p-32"
          headers={[
            { title: '‫ردیف‬', size: 2 },
            { title: 'عنوان', size: 6 },
            { title: 'حدنصاب', size: 2 },
            { title: 'امتیاز', size: 2 },
            { title: 'وضعیت', size: 2 },
            { title: 'رتبه', size: 1 },
            { title: 'سطح', size: 2 },
            { title: 'آرشیو', size: 1 },
          ]}
          rows={(activeTab === 1 ? exams : archivedExams).map(exam => ({
            onClick: () => { setSelectedExam(exam); setShowDetailModal(true) },
            data: [
              exam.exam.title,
              exam.exam.pass_percent + ' درصد',
              `%${exam.percent?.toString().slice(0, 5)}` + ' درصد',
              {
                icon: () => <span className={detectExamStatus(exam.percent, exam.exam.pass_percent) ? "text-success" : "text-tomato"}>
                  {detectExamStatus(exam.percent, exam.exam.pass_percent) ? 'قبول' : 'مردود'}
                </span>
              },
              exam.rank,
              detectDifficulty(exam.exam.difficulty),
              {
                icon: () => <button className="bd-none bg-none blocked"
                  onClick={() => setFocusedExamId(exam.id)}>
                  <img src={activeTab === 1 ? Archive : UnArchive} alt="" className="blocked" style={{ width: 24 }} />
                </button>
              },
            ]
          }))} /> : <div className="text-center p-32">موردی یافت نشد</div>}
        {!isLoading && <Pagination currentPage={(activeTab === 1 ? page : archivedpage)}
          count={Math.ceil((activeTab === 1 ? count : archivedCount) / 50)}
          setPage={activeTab === 1 ? setPage : setArchivedPage} />}
      </div>

      <MessageBox show={focusedExamId > 0} toggleShow={() => setFocusedExamId(-1)}
        title={'آرشیو کردن کارنامه'}
        description={activeTab === 1 ? 'آیا می خواهید کارنامه را بایگانی  نمایید؟' :
          'آیا میخواهید کارنامه را از بایگانی خارج نمایید؟'}
        onAccept={archiveExam} />

      <TakenExamDetailModal full show={showDetailModal} toggleShow={setShowDetailModal} exam={selectedExam} />
      <Loading full show={isLoading} />
    </div>
  )
}
